<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Gib Kullanıcı sorgulama</h3>
          </div>
          <div>
           
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Gib Tanımlayıcı</label>
                    <input type="text"  :class="{ 'is-invalid': $v.gibUseRequest.identifier.$error }" v-model="gibUseRequest.identifier" class="form-control m-input" placeholder="Gib kullanıcı tanımlayıcısı (vergi kimlik no yada TC kimlik no)." />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Tip</label>

                     <select   
                            v-model="gibUseRequest.type" class="form-control m-input" 
                            placeholder="Tip Seçiniz.">
                            <option
                                v-for="option in types" 
                                v-bind:value="option.id"
                                v-bind:key="option.description"
                                >{{ option.description }}</option
                              >
                                      </select>

                 </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="queryGibUser()" class="btn m-btn--pill btn-primary">Sorgula</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

          <!--begin::Gib Result-->

<div>
   <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <table
                      class="table table-striped- table-bordered table-hover table-checkable dataTable no-footer dtr-inline"
                      id="m_table_1"
                      role="grid"
                      aria-describedby="m_table_1_info"
                      style="width: 1457px;"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="2"
                            style="width: 57.5px;"
                            aria-label="Order ID: activate to sort column ascending"
                          >Sonuçlar</th>
                        </tr>
                      </thead>
                                   <tr>
                        <td colspan="2"> Sorgu
                        </td>
                                   </tr>
                      <tr>
                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Gib Tanımlayıcı</label>
                    <label class="form-control m-input">{{gibUseRequest.identifier}}</label>
                  </div>
                </div>
                        </td>
                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Tip</label>
                    <label class="form-control m-input">{{getTypeDesc( gibUseRequest.type)}}</label>
                  </div>
                </div>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="5"> Cevap
                        </td>
                      </tr>
                      <tr>
                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>EFatura PK</label>
                    <label class="form-control m-input">{{gibUseResponse.eInvoicePk}}</label>
                  </div>
                </div>
                        </td>
                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>EFatura GB</label>
                    <label class="form-control m-input">{{gibUseResponse.eInvoiceGb}}</label>
                  </div>
                </div>
                        </td>
                         <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Eİrsaliye PK</label>
                    <label class="form-control m-input">{{gibUseResponse.eDispatchPk}}</label>
                  </div>
                </div>
                        </td>
                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Eİrsaliye GB</label>
                    <label class="form-control m-input">{{gibUseResponse.eDispatchGb}}</label>
                  </div>
                </div>
                        </td>

                          <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Aktif</label>
                    <label class="form-control m-input">{{gibUseResponse.isActive?"Evet":"Hayır" }}</label>
                  </div>
                </div>
                        </td>
                      </tr>
          </table>
              </div>
                  </div>
                </div>
              </div>
</div>
          <!--end::Gib Result-->

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  
</template>
<script>
import { required } from "vuelidate/lib/validators";
import {_requestGibUser} from '../../services/EProcessService'

export default {
created() {
  if(this.$route.query.identifier != null && this.$route.query.type != null)
        {
          this.gibUseRequest.identifier=this.$route.query.identifier;
          this.gibUseRequest.type=this.$route.query.type;
              this.queryGibUser();
        }
},
  data() {
    return {
      gibUseRequest: {
      "identifier":"",
      "type":0
      },
      gibUseResponse: {
         "eInvoicePk":"",
        "eInvoiceGb":"",
        "eDispatchPk":"",
        "eDispatchGb":"",
        "isActive":false,
        "success":false
    },
types : [
  {
    description: "E irsaliye",
    id: 1
  },
  {
    description :"E fatura",
    id: 2
  }
]
    }
  },
    validations: {
    
      gibUseRequest: {
        identifier: { required },
           type: { required }
      }
    
  },
methods: {
  queryGibUser:function(){
          this.$v.gibUseRequest.$touch();
      if (this.$v.gibUseRequest.$error) return;
          // let loader=this.$loading.show();
    _requestGibUser(this.gibUseRequest).then(response=>{
      // loader.hide();
     // if(response.data.success)
        this.gibUseResponse = response.data;
    });
  },
  getTypeDesc(typeid)
  {
    if (typeid != null)
    {
    var mytype = this.types.find(a=> a.id == typeid);
    if (mytype!= null)
    return mytype.description;
  }
  return "";
  }
  
}
};
</script>